import React, { FunctionComponent, useState } from 'react';
import WideContent from 'core/layout/content/wide-content';
import { AdminProductDetail } from 'api';
import Translate from 'ui/atoms/translate';
import ProductInvitationsTable from './invitations-table';
import IssuerCreateInvestmentInvitation from './create-investment-invitation';
import useGoTo from 'hooks/use-go-to';
import { ISSUER_ROUTES } from 'apps/issuer/pages/routes.config';
import { currentTokenHasManageDistributionPermission } from 'src/apps/issuer/helpers/tokenPermissions';
import PageWrapper from 'src/core/layout/content/page-wrapper';

interface ProductInvitationProps {
  hasListings: boolean;
  productId: string;
  product: AdminProductDetail;
  setFilterPopupHeight?: (height: number) => void;
}

const ProductInvitations: FunctionComponent<ProductInvitationProps> = ({
  hasListings,
  product,
  productId,
  setFilterPopupHeight,
}) => {
  const [refreshData, setRefreshData] = useState(false);

  const goToInvitationDetails = useGoTo(ISSUER_ROUTES.investmentInvitationDetails);

  let canManage;
  if (product) {
    canManage = currentTokenHasManageDistributionPermission(product);
  }

  return (
    <WideContent
      title={<Translate name="dashboard.issuerInvestmentInvitationsTitle" />}
      ignorePageTitle
      titleSpacing="medium"
      headerPanel={
        canManage ? (
          <IssuerCreateInvestmentInvitation
            hasListings={hasListings}
            onCloseAfterSuccess={() => setRefreshData(!refreshData)}
            product={product}
          >
            <Translate name="investmentInvitation.create.long" />
          </IssuerCreateInvestmentInvitation>
        ) : null
      }
    >
      <ProductInvitationsTable
        productId={productId}
        goToDetails={(invitationId: string) => goToInvitationDetails({ invitationId })}
        defaultLimit={10}
        setFilterPopupHeight={setFilterPopupHeight}
      />
    </WideContent>
  );
};

export default ProductInvitations;
